/* eslint-disable react-hooks/exhaustive-deps */
import { InputText } from "primereact/inputtext";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { DataTable, DataTableFilterMeta, DataTableSelectionSingleChangeEvent } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Toast } from "primereact/toast";
import { classNames } from 'primereact/utils';
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import React from "react";
import { Dialog } from "primereact/dialog";
import { Link } from "react-router-dom";
import Chart from "../../models/Chart";
import { useMsal } from "@azure/msal-react";
import { Dropdown } from "primereact/dropdown";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import autoTable from "jspdf-autotable";
import { SetupOptionsService } from "../../service/SetupOptionsService";
import SetupOptions from "../../models/SetupOptions";
import MaintenanceService from "../../service/MaintenanceService";
import Code from "../../models/Code";

interface DropdownItem {
    name: string;
    code: string;
}

const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    chartCd: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    chartType: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    chartDesc: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    chartStatus: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    chartDefinition: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    chartComment: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    chartUpdTs: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    chartUpdUser: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    }
};

export default function ChartView() {
    let empty: Chart = {
        chartCd: '',
        chartDesc: '',
        chartComment: '',
        chartDefinition: '',
        chartStatus: '',
        chartType: '',
        chartUpdTs: '',
        chartUpdUser: ''
    };

    const status: DropdownItem[] = useMemo(
        () => [
            { name: 'Active', code: 'A' },
            { name: 'Suspended', code: 'S' },
            { name: 'Deleted', code: 'D' }
        ],
        []
    );

    const [listValues, setListValues] = useState<Chart[]>([]);
    const [listFilteredData, setListFilteredData] = useState<Chart[]>([]);
    const [listChartDefinitions, setListChartDefinitions] = useState<SetupOptions[]>([]);
    const [listSetupTypes, setListSetupTypes] = useState<Code[]>([]);
    const [singleValue, setSingleValue] = useState<Chart>(empty);
    const [loading, setLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const isNew = useRef(false);
    const form = useForm();
    const formEdit = useForm({ mode: "onChange" });
    const [editingRows, setEditingRows] = useState({});
    const errors = form.formState.errors;
    const toast = useRef<any>(null);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const { accounts } = useMsal();
    const [updateTrigger, setUpdateTrigger] = useState(0);
    const dt = useRef<any>(null);

    useEffect(() => {
        initFilters();
    }, []);

    useEffect(() => {
        MaintenanceService.getCharts().then(data => {
            setListValues(data);
            setLoading(false);
        });

        SetupOptionsService.getSetupOptByType('DEF').then(data => {
            setListChartDefinitions(data);
        });

        MaintenanceService.getSetupTypes().then(data => {
            setListSetupTypes(data);
        });
    }, []);

    useEffect(() => {
        MaintenanceService.getCharts().then(data => {
            setListValues(data);
            setLoading(false);
        });
    }, [updateTrigger]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const getFilteredData = () => {
        const data = listFilteredData.length > 0 ? listFilteredData : dt.current.props.value;

        const bodyData = data.map((item: Chart) => [
            item.chartCd,
            item.chartType,
            item.chartDesc,
            item.chartStatus,
            item.chartDefinition,
            item.chartComment,
            item.chartUpdTs,
            item.chartUpdUser
        ]);

        return bodyData;
    };

    const exportPdf = () => {
        const bodyData = getFilteredData();
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default("l");
                autoTable(doc, { head: [['Chart Code', 'Chart Type', 'Description', 'Chart Status', 'Chart Definition', 'Comments', 'Last Update Date', 'Last Update User']], body: bodyData })
                doc.save('charts.pdf');
            });
        });
    };

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilter(value);
    };

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);
    const initFilters = () => {
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = null;
        setFilters(defaultFilters);
        setGlobalFilter('');
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <div>
                <i className="pi pi-file-excel ml-3 text-green-500 cursor-pointer" title="Export CSV" onClick={(e) => { exportCSV(); e.stopPropagation(); }} />
                <i className="pi pi-file-pdf ml-3 text-red-500 cursor-pointer" title="Export PDF" onClick={(e) => { exportPdf(); e.stopPropagation(); }} />
            </div>
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" value={globalFilter} onChange={onGlobalFilterChange} placeholder="Search..." />
            </IconField>
        </div>
    );

    const chartCdTemplate = (rowData: Chart) => {
        return rowData.chartCd;
    }

    const chartDescTemplate = (rowData: Chart) => {
        return rowData.chartDesc;
    }

    const chartStatusTemplate = (rowData: Chart) => {
        return rowData.chartStatus;
    }

    const chartTypeTemplate = (rowData: Chart) => {
        return rowData.chartType;
    }

    const chartDefinitionTemplate = (rowData: Chart) => {
        return rowData.chartDefinition;
    }

    const chartCommentTemplate = (rowData: Chart) => {
        return rowData.chartComment;
    }

    const chartUpdtsTemplate = (rowData: Chart) => {
        return rowData.chartUpdTs;
    }

    const chartUpduserTemplate = (rowData: Chart) => {
        return rowData.chartUpdUser;
    }

    const clearNew = () => {
        form.reset();
    }

    const getErrorMessage = (name: string) => {
        return errors[name] ? <small className="p-error">{(errors[name] as any).message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const onSubmit = (data: any) => {
        isNew.current = true;
        let _value = { ...singleValue };
        _value.chartCd = data.chartCd;
        _value.chartComment = data.chartComment;
        _value.chartDefinition = data.chartDefinition;
        _value.chartDesc = data.chartDesc;
        _value.chartStatus = data.chartStatus;
        _value.chartType = data.chartType;
        _value.chartComment = data.chartComment;

        if (accounts[0]) {
            _value.chartUpdTs = new Date().toISOString();
            _value.chartUpdUser = accounts[0].username.split('@')[0];
        }

        save(_value);
        form.reset();
    };

    const save = (value: Chart) => {
        MaintenanceService.addChart(value).then(() => {
            setUpdateTrigger(prev => prev + 1);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Chart Created', life: 3000 });
            setSingleValue(empty);
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Create Chart', life: 3000 });
        });
    }

    const update = (value: Chart, oldId: string) => {
        MaintenanceService.updateChart(value, oldId).then(() => {
            setUpdateTrigger(prev => prev + 1);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Chart Updated', life: 3000 });
            setSingleValue(empty);
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Chart', life: 3000 });
        });
    }

    const setActiveRowIndexCE = (rowData: DataTableSelectionSingleChangeEvent<Chart[]>) => {
        let selectedIndex = listValues.findIndex(v => v.chartCd === (rowData.value as Chart).chartCd);
        let _editingRows = { ...editingRows, ...{ [`${listValues[selectedIndex].chartCd}`]: true } };
        if (Object.keys(_editingRows).length === 1) {
            setEditingRows(_editingRows);
        }
    }

    const onRowEditChange = (e: any) => {
        setEditingRows(e.data);
    }

    const onRowEditComplete = (e: any) => {
        let _listValues = [...listValues];
        let { newData } = e;
        let index = listValues.findIndex(v => v.chartCd === newData.chartCd);
        _listValues[index] = newData;

        setListValues(_listValues);
    }

    const cellEditor = (options: ColumnEditorOptions) => {
        switch (options.field) {
            case 'chartCd':
                return chartCdEditor(options);

            case 'chartType':
                return chartTypeEditor(options);

            case 'chartDesc':
                return chartDescEditor(options);

            case 'chartStatus':
                return chartStatusEditor(options);

            case 'chartDefinition':
                return chartDefinitionEditor(options);

            case 'chartComment':
                return chartCommentEditor(options);
        }
    }

    const chartCdEditor = (options: any) => {
        return (
            <Controller
                name="chartCdEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Code is required.',
                    validate: {
                        unique: v => listValues.filter(val => val.chartCd.toLowerCase() === v.toLowerCase()).length === 0 || 'Code must be unique.'
                    }
                }}
                render={({ field, fieldState }) => {
                    singleValue.chartCd = field.value;

                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={50} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.chartCd = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Code" />
                        </>
                    )
                }
                }
            />
        );
    }

    const chartTypeEditor = (options: any) => {
        return (
            <Controller
                name="chartTypeEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Setup Type is required.'
                }}
                render={({ field, fieldState }) => {
                    singleValue.chartType = field.value;
                    return (
                        <>
                            <Dropdown inputId={field.name} ref={field.ref} value={fieldState.isDirty ? field.value : options.value} options={listSetupTypes} optionLabel="codeId" optionValue="codeId" tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { singleValue.chartType = e.target.value; field.onChange(e.target.value); }} placeholder="Select..." />
                        </>
                    )
                }
                }
            />
        );
    }

    const chartDescEditor = (options: any) => {
        return (
            <Controller
                name="chartDescEdit"
                control={formEdit.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    singleValue.chartDesc = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={50} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.chartDesc = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Description" />
                        </>
                    )
                }
                }
            />
        );
    }

    const chartStatusEditor = (options: any) => {
        return (
            <Controller
                name="chartStatusEdit"
                defaultValue={options.value}
                control={formEdit.control}
                render={({ field, fieldState }) => {
                    singleValue.chartStatus = field.value;
                    return (
                        <>
                            <Dropdown ref={field.ref} inputId={field.name} value={fieldState.isDirty ? field.value : options.value} options={status} optionLabel="name" optionValue="code" tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { singleValue.chartStatus = e.value; field.onChange(e.value); }} placeholder="Select..." />
                        </>
                    )
                }}
            />
        );
    }

    const chartDefinitionEditor = (options: any) => {
        return (
            <Controller
                name="chartDefinitionEdit"
                defaultValue={options.value}
                control={formEdit.control}
                render={({ field, fieldState }) => {
                    singleValue.chartDefinition = field.value;
                    return (
                        <>
                            <Dropdown inputId={field.name} ref={field.ref} value={fieldState.isDirty ? field.value : options.value} options={listChartDefinitions} optionLabel="setupDescription" optionValue="setupOption" tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { singleValue.chartDefinition = e.value; field.onChange(e.value); }} placeholder="Select..." />
                        </>
                    )
                }}
            />
        );
    }

    const chartCommentEditor = (options: any) => {
        return (
            <Controller
                name="chartCommentEdit"
                control={formEdit.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    singleValue.chartComment = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={255} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.chartComment = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Comment" />
                        </>
                    )
                }
                }
            />
        );
    }

    const rowEditorTemplate = (rowData: Chart, props: any) => {
        const rowEditor = props.rowEditor;
        if (rowEditor.editing) {
            isNew.current = false;

            return (
                <>
                    <Button icon="p-row-editor-save-icon pi pi-fw pi-save" title="Save" rounded text severity="info" type="submit" onClick={(e) => {
                        if (!formEdit.getFieldState("chartCdEdit").invalid && !formEdit.getFieldState("chartDescEdit").invalid) {
                            let _singleValue = { ...singleValue };
                            let oldId = rowData.chartCd;

                            if (accounts[0]) {
                                console.log(rowData);
                                _singleValue.chartUpdTs = new Date().toISOString();
                                _singleValue.chartUpdUser = accounts[0].username.split('@')[0];
                            }

                            update(_singleValue, oldId);
                            formEdit.reset();
                            rowEditor.onSaveClick(e);
                        }
                    }} />

                    <Button icon="p-row-editor-cancel-icon pi pi-fw pi-undo" title="Undo" rounded text severity="danger" onClick={(e) => {
                        formEdit.clearErrors();
                        formEdit.reset();
                        rowEditor.onCancelClick(e);
                    }} />
                </>
            );
        } else {
            return (
                <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDelete(rowData)} to={''}></Link>
            );
        }
    }

    const hideDeleteDialog = () => {
        setDeleteDialog(false);
    };

    const confirmDelete = (value: Chart) => {
        setSingleValue(value);
        setDeleteDialog(true);
    }

    const deleteRow = () => {
        MaintenanceService.deleteChart(singleValue.chartCd).then(() => {
            setUpdateTrigger(prev => prev + 1);
            setDeleteDialog(false);
            setSingleValue(empty);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Deleted', life: 3000 });
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to remove', life: 3000 });
        });

    };

    const deleteDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteRow} />
        </React.Fragment>
    );

    return (
        <>
            <Toast ref={toast} />

            <Panel header="Add Chart" className="addPanel mb-2 -ml-2">
                <form onSubmit={form.handleSubmit(onSubmit)} className="p-fluid" autoComplete="off">
                    <div className="formgrid grid">
                        <div className="field col-2">
                            <Controller
                                name="chartCd"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Code is required.',
                                    validate: {
                                        unique: v => listValues.filter(val => val.chartCd.toLowerCase() === v.toLowerCase()).length === 0 || 'Chart code must be unique.'
                                    }
                                }}
                                render={({ field, fieldState }) => (

                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Chart Code</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={8} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { field.onChange(e.target.value.toUpperCase()); }} placeholder="Chart Code" />
                                        {(field.value !== null && field.value !== undefined) ? <small className="text-primary">{field.value}</small> : <></>}
                                        {getErrorMessage('chartCd')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="chartType"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Setup Type is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Chart Type</label>
                                        <Dropdown inputId={field.name} value={field.value} options={listSetupTypes} optionLabel="codeId" optionValue="codeId" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                            onChange={(e) => { field.onChange(e.value) }} placeholder="Select..." />
                                        {getErrorMessage('chartType')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="chartDesc"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Description is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Description</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={25} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.target.value.toUpperCase())} placeholder="Description" />
                                        {(field.value !== null && field.value !== undefined) ? <small className="text-primary">{field.value}</small> : <></>}
                                        {getErrorMessage('chartDesc')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="chartStatus"
                                defaultValue={'A'}
                                control={form.control}
                                rules={{
                                    required: 'Status is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Chart Status</label>
                                        <Dropdown inputId={field.name} value={field.value} options={status} optionLabel="name" optionValue="code" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                            onChange={(e) => { field.onChange(e.value) }} placeholder="Select..." />
                                        {getErrorMessage('chartStatus')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="chartDefinition"
                                defaultValue={''}
                                control={form.control}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Chart Definition</label>
                                        <Dropdown inputId={field.name} value={field.value} options={listChartDefinitions} optionLabel="setupDescription" optionValue="setupOption" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                            onChange={(e) => { field.onChange(e.value) }} placeholder="Select..." />
                                        {getErrorMessage('chartDefinition')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="chartComment"
                                control={form.control}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Comments</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={255} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.target.value.toUpperCase())} placeholder="Comments" />
                                        {(field.value !== null && field.value !== undefined) ? <small className="text-primary">{field.value}</small> : <></>}
                                        {getErrorMessage('chartComment')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field field-buttons col-2 pt-4">
                            <Button icon="pi pi-save" title="Save" rounded text severity="info" type="submit" />
                            <Button icon="pi pi-undo" title="Undo" rounded text severity="danger" type="button" onClick={clearNew} />
                        </div>
                    </div>
                </form>
            </Panel>

            <DataTable ref={dt} className="-ml-2" value={listValues} selectionMode="single" onSelectionChange={setActiveRowIndexCE}
                dataKey="chartCd" size="small" rowHover={true} loading={loading}
                scrollable scrollHeight="calc(100vh - 23.9rem)"
                paginator rows={25} rowsPerPageOptions={[5, 10, 25]} alwaysShowPaginator={false}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                editingRows={editingRows} editMode="row" onRowEditChange={onRowEditChange} onRowEditComplete={onRowEditComplete}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                filters={filters} emptyMessage="No chart records found." header={header} onValueChange={filteredData => setListFilteredData(filteredData)}>
                <Column field="chartCd" header="Chart Code" sortable body={chartCdTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="chartType" header="Chart Type" sortable body={chartTypeTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="chartDesc" header="Description" sortable body={chartDescTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="chartStatus" header="Chart Status" sortable body={chartStatusTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="chartDefinition" header="Chart Definition" sortable body={chartDefinitionTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="chartComment" header="Comments" sortable body={chartCommentTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="chartUpdTs" header="Last Update Date" sortable body={chartUpdtsTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="chartUpdUser" header="Last Update User" sortable body={chartUpduserTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column rowEditor body={rowEditorTemplate} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
            </DataTable>

            <Dialog visible={deleteDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteDialogFooter} onHide={hideDeleteDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {singleValue && (
                        <span>
                            Are you sure you want to delete <b>{singleValue.chartCd}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
        </>
    )
}